<template>
  <div class="serviceImageSlider">
    <div
      class="overflow-hidden"
      :style="{
        width: `${width}px`,
        height: useThumb ? 'auto' : `${height}px`,
      }"
    >
      <Swiper
        class="swiperTop bg-slate-100 border"
        :class="{ 'mb-4': useThumb }"
        :slides-per-view="1"
        :space-between="spaceBetween"
        :thumbs="useThumb ? { swiper: state.thumbsSwiper } : {}"
        :navigation="useNavigation"
      >
        <SwiperSlide v-for="(item, key) in images" :key="'topImage' + key">
          <div
            class="flex items-center justify-center"
            :style="{ width: `${width}px`, height: `${height}px` }"
          >
            <img :src="item.file" class="max-w-full max-h-full m-auto" />
          </div>
        </SwiperSlide>
      </Swiper>
      <div v-show="images.length > 1">
        <Swiper
          v-if="useThumb"
          class="swiperThumb"
          :slides-per-view="4.8"
          :slideToClickedSlide="true"
          :watchSlidesVisibility="true"
          :watchSlidesProgress="true"
          @swiper="setThumbsSwiper"
        >
          <SwiperSlide v-for="(item, key) in images" :key="'thumbnail' + key">
            <div
              class="flex items-center justify-center bg-slate-100 border"
              style="width: 114px; height: 80px"
            >
              <img :src="item.file" class="max-w-full max-h-full m-auto" />
            </div>
          </SwiperSlide>
        </Swiper>
      </div>
    </div>
  </div>
</template>

<script>
import { reactive, onUpdated } from 'vue';
import SwiperCore, { Thumbs, Navigation } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/vue';
import 'swiper/swiper-bundle.css';
SwiperCore.use([Thumbs, Navigation]);

export default {
  props: {
    images: {
      type: Array,
      required: true,
      default: () => [],
    },
    width: Number,
    height: Number,
    spaceBetween: Number,
    useNavigation: Boolean,
    useThumb: Boolean,
  },
  components: {
    Swiper,
    SwiperSlide,
  },
  setup() {
    const state = reactive({
      thumbsSwiper: null,
    });
    const setThumbsSwiper = (swiper) => {
      state.thumbsSwiper = swiper;
    };
    onUpdated(() => {
      state.thumbsSwiper = null;
    });
    return {
      state,
      setThumbsSwiper,
    };
  },
};
</script>

<style lang="scss">
// swiperで生成される要素でdata属性が付与されないためscopedなしで指定
.serviceImageSlider {
  .swiperTop {
    &.swiper-container {
      overflow: initial;
      &:hover {
        .swiper-button-prev,
        .swiper-button-next {
          display: flex;
        }
      }
    }
    .swiper-button-prev,
    .swiper-button-next {
      display: none;
      width: 18px;
      height: 36px;
      background: #183360;
      &:after {
        color: #fff;
        font-size: 12px;
      }
    }
    .swiper-button-prev {
      border-radius: 0 4px 4px 0;
      animation: btn-prev 0.15s forwards;
    }
    .swiper-button-next {
      border-radius: 4px 0 0 4px;
      animation: btn-next 0.15s forwards;
    }
  }
}
@keyframes btn-prev {
  from {
    opacity: 0;
    left: -18px;
  }
  to {
    opacity: 0.7;
    left: 0;
  }
}
@keyframes btn-next {
  from {
    opacity: 0;
    right: -18px;
  }
  to {
    opacity: 0.7;
    right: 0;
  }
}
</style>

<style lang="scss" scoped>
.swiperThumb {
  .swiper-slide {
    opacity: 0.5;
    &.swiper-slide-thumb-active {
      opacity: 1;
    }
  }
}
</style>
